import VueRouter from "vue-router";
import routes from "@/routes";
import Vue from 'vue';
import qs from "qs";
import UrlParameterService from "@/utils/Services/SearchParameters/UrlParameterService";

Vue.use(VueRouter);

export default new VueRouter({
    routes,
    base: '/vuetify/',
    // Use the HTML5 history API (i.e. normal-looking routes)
    // instead of routes with hashes (e.g. example.com/#/about).
    // This may require some server configuration in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    mode: 'history',
    // Simulate native-like scroll behavior when navigating to a new
    // route and using back/forward buttons.
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    parseQuery(queryString) {
        let object = qs.parse(queryString);

        return UrlParameterService.formatQueryParameters(object);
    },
    stringifyQuery(object) {
        const result = qs.stringify(object);
        return result ? ('?' + result) : '';
    }
});
